import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import TitlePages from 'components/_base/TitlePages';
import Bottom from 'components/Bottom';
import ContentRelatorios from './ContentRelatorios';

const Relatorios = () => {
  return (
    <>
      <HeaderApp />
      <div className="panel">
        <TitlePages title="Relatórios" />
        <hr />
        <ContentRelatorios />
      </div>
      <Bottom />
    </>
  );
};

export default Relatorios;
